//
//
//
//
//
//

export default {
	props: ["id", "Data1", "Data2", "Color"],
	data() {
		return {
			legendName: [],
		};
	},
	mounted() {
		setTimeout(() => {
			this.drawLine();
		}, 1000);
	},
	watch: {
		Data2() {
			this.drawLine();
		}
	},
	methods: {
		fontSize(res) {
			let docEl = document.documentElement,
				clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			if (!clientWidth) return;
			let fontSize = 100 * (clientWidth / 1920);
			// alert(fontSize)
			return res * fontSize;
		},
		drawLine() {
			var colorrr = "[{offset: 1,color: 'rgba(241,107,158,0)'},{offset: 0,color: 'rgba(241,107,158,0.5)'}]"
			let myChart = this.$echarts.init(document.getElementById(this.id));
			myChart.clear()
			myChart.setOption({
				grid: {
					top: '12%',
					left: '10%',
					right: '10%',
					bottom: '15%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					name: '点',
					nameTextStyle: {
						color: "rgba(102,152,255,1)",
						fontSize: this.fontSize(0.1),
						// fontSize:'0.36rem',  
						padding: 0
					},
					boundaryGap: true, ////////x轴前面是否留白
					data: this.Data1,
					// data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
					axisLabel: {
						formatter: '{value}',
						textStyle: { //改变刻度字体样式
							fontWeight: '400',
							color: 'rgba(165,195,252,1)',
							// fontSize:'0.31rem'
							fontSize: this.fontSize(0.1),
						}
					},
					axisLine: {
						lineStyle: {
							color: '#4D30F0'
						}
					}
					// boundaryGap: ['10'],//坐标轴两边留白
				},
				yAxis: {
					type: 'value',
					name: '人数',
					nameTextStyle: {
						color: "rgba(102,152,255,1)",
						// fontSize:'0.36rem',  
						fontSize: this.fontSize(0.1),
						padding: 0
					},
					minInterval: 1,
					splitLine: {
						show: false //网格线不显示
					},
					axisLabel: {
						formatter: '{value}',
						textStyle: { //改变刻度字体样式
							fontWeight: '400',
							color: 'rgba(165,195,252,1)',
							// fontSize:'0.31rem'
							fontSize: this.fontSize(0.1),
						}
					},
					axisLine: {
						lineStyle: {
							color: '#4D30F0'
						}
					}
				},

				series: [{

					// data: [40, 50, 80, 25, 45, 40, 55,75,90,82,65,55],
					type: 'line',
					areaStyle: {},
					symbol: 'circle',
					itemStyle: { //折线拐点标志的样式。

						normal: {
							color: '#06b9f6',
							type: 'dashed'
						},
					},
					areaStyle: { //区域填充样式
						normal: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 1,
									color: 'rgba(0,196,245,0)'
								}, {
									offset: 0,
									color: 'rgba(0,196,245,0.5)'
								}],
								globaCoord: false,
							},
						},
					},
					data: this.Data2,
				}]
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/zhexian_mianji.vue